import styled from "styled-components";
import { variant } from "styled-system";
import { commonComposes } from "../common/commonComposes";
import { ButtonProps } from "./types";
import { theme } from "theme/theme";

export const Button = styled("button")<ButtonProps>(
  (props) => ({
    cursor: props.disabled ? "not-allowed" : "pointer",
    "&:hover": props._hover ?? {
      // opacity: props.disabled ? 0.8 : 0.3,
      transition: "all 0.2s ease-in-out",
    },
    opacity: props.disabled ? 0.3 : 1,
    fontFamily: "Poppins, sans-serif",
  }),
  variant({
    variants: {
      primary: {
        width: "max-content",
        fontWeight: 500,
        fontSize: "16px",
        fontFamily: "Poppins, sans-serif",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        backgroundColor: theme.colors.typePurpure[200],
        borderRadius: "15px",
        padding: "10px 20px",
        border: "none",
      },
      ghost: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#8450A0",
        backgroundColor: "transparent",
        borderRadius: "10px",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        // padding: "11.5px 20px",
        "&:hover": {
          background: theme.colors.black[200],
        },
      },
      secondary: {
        width: "max-content",
        fontWeight: 500,
        fontSize: "16px",
        fontFamily: "Poppins, sans-serif",
        color: theme.colors.typePurpure[200],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        backgroundColor: "white",
        borderRadius: "50px",
        padding: "10px 20px",
        border: `1px solid ${theme.colors.typePurpure[200]}`,
      },
      sm_secondary: {
        width: "max-content",
        fontWeight: 500,
        fontSize: "16px",
        fontFamily: "Poppins, sans-serif",
        color: theme.colors.black[900],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        backgroundColor: "white",
        borderRadius: "10px",
        padding: "10px 20px",
        border: `2px solid ${theme.colors.secondary}`,
      },
      getStarted: {
        backgroundColor: theme.colors.typeGreen[100],
        border: "1px solid #4D39CC",
        borderRadius: "16px",
        color: "#4D39CC",
        cursor: "pointer",
        fontSize: ["16px", "20px", "16px"],
        fontWeight: 600,
        padding: "16px 25px",
        maxWidth: "100% !important",
        width: "472px !important",
      },
      smallCTA: {
        backgroundColor: theme.colors.typeGreen[100],
        fontSize: theme.fontSizes[2],
        color: theme.colors.black[900],
        fontWeight: 600,
        border: "1px solid #4D39CC",
        borderRadius: "16px",
        padding: "16px 22.5px",
        cursor: "pointer",
        maxWidth: "100%",
        width: "max-content",
      },
    },
  }),
  commonComposes()
);

Button.defaultProps = {
  variant: "primary",
};
